import { HIGHLIGHTS } from "@/data/staticContent";
import { GraduationCap, Wallet, Globe2, Building2, Palette, Award } from "lucide-react";

const ICONS = [GraduationCap, Wallet, Globe2, Building2, Palette, Award];
const TONES = [
  "bg-white text-[#D52B1E] ring-red-100",
  "bg-white text-[#1F4A3A] ring-emerald-100",
  "bg-white text-[#0E7C86] ring-teal-100",
  "bg-white text-amber-700 ring-amber-100",
  "bg-white text-slate-700 ring-slate-200",
  "bg-white text-[#D52B1E] ring-red-100",
];

export default function HighlightBar() {
  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8" data-testid="highlight-bar">
      <div className="flex flex-wrap justify-center gap-2 md:gap-3">
        {HIGHLIGHTS.map((h, i) => {
          const Icon = ICONS[i % ICONS.length];
          const tone = TONES[i % TONES.length];
          return (
            <span
              key={h}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full ${tone} ring-1 text-xs md:text-sm font-semibold shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-transform`}
            >
              <Icon className="w-3.5 h-3.5" />
              {h}
            </span>
          );
        })}
      </div>
    </div>
  );
}
